/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ /**
 * The entry point for the admin side wp-admin resource.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/lib/antd.scss";
import { fetchStatus, refreshQueue, restoreJobsFromLocalStorage, lockTab, createActivityDetector, clearWorkerNotifications, checkWorkerNotifications } from "./queue";
import { CLIENT_JOB_EVENT_PREFIX } from "./types";
import { ErrorModal, Provider } from "./components";
import { createRoot } from "react-dom/client";
import { waitObject, ready } from "@devowl-wp/react-utils";
ready(async ()=>{
    // Only allow queue runtime for one tab
    await waitObject(()=>lockTab() ? undefined : "unlocked", 3000);
    window.addEventListener("beforeunload", ()=>lockTab(false));
    lockTab(true);
    // Create error modal
    const errorModalElement = document.createElement("div");
    document.body.appendChild(errorModalElement);
    createRoot(errorModalElement).render(/*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(ErrorModal, {})
    }));
    // Mark this tab as worker
    clearWorkerNotifications();
    window.realQueueWorker = true;
    setInterval(()=>checkWorkerNotifications({
            refreshQueue
        }), 3000);
    const addedFromLocalStorage = await restoreJobsFromLocalStorage();
    if (!addedFromLocalStorage) {
        // No new items from LocalStorage, check if queue has new items
        refreshQueue(false);
    }
}, "interactive");
ready(()=>{
    createActivityDetector();
    fetchStatus(60000);
    // When the tab gets visible, immediate fetch status
    document.addEventListener("visibilitychange", ()=>{
        if (document.visibilityState === "visible") {
            fetchStatus(true);
        }
    });
});
// Example implementation of a client job
document.addEventListener(`${CLIENT_JOB_EVENT_PREFIX}example`, async (param)=>{
    let { detail: { job, resolve, fetchJob, saveJobResult } } = param;
    console.log("Lock this job and sleep...", job);
    const { id, process_total } = job;
    await fetchJob(id, true);
    await new Promise((resolve)=>setTimeout(resolve, 5000));
    saveJobResult(id, process_total);
    resolve();
});
export * from "./hooks";
export * from "./types";
export * from "./utils";
export * from "./queue";
export * from "./wp-api";
